import { useState } from 'react'
import { SelectField, TextField } from '@krp/ui-kit'
import './cashiers.css'

/** Сколько кассиров показывает список сразу; остальных находят поиском по имени. */
export const CASHIER_PICKER_LIMIT = 10
export const OWN_ONLY_NOTE = 'Вам доступен просмотр только вашего кассира'

export interface PickerPerson { id: string; name: string }
export interface CashierPickerChoices { items: PickerPerson[]; total: number }

/**
 * Кассиры для выпадающего списка: подходящие под поиск по имени, не больше `limit`. Выбранный кассир остаётся в списке,
 * даже когда поиск его уже не находит, — иначе выбор молча сбросился бы.
 */
export function cashierPickerChoices(people: readonly PickerPerson[], search: string, selectedId: string, limit = CASHIER_PICKER_LIMIT): CashierPickerChoices {
  const needle = search.trim().toLocaleLowerCase('ru-RU')
  const matching = needle === '' ? people : people.filter((person) => person.name.toLocaleLowerCase('ru-RU').includes(needle))
  const items = matching.slice(0, limit)
  const selected = people.find((person) => person.id === selectedId)
  if (selected !== undefined && !items.some((person) => person.id === selected.id)) items.unshift(selected)
  return { items, total: matching.length }
}

export interface CashierPickerProps {
  people: readonly PickerPerson[]
  /** Выбранный кассир; пусто — не выбран. */
  value: string
  onChange: (personId: string) => void
  /** Выбор заблокирован: аккаунту разрешён только привязанный кассир. */
  locked: boolean
}

/** Выбор кассира статистики: поиск по имени и первые кассиры списка; без права «видеть любого» выбор заблокирован. */
export function CashierPicker({ people, value, onChange, locked }: CashierPickerProps) {
  const [search, setSearch] = useState('')
  const choices = cashierPickerChoices(people, locked ? '' : search, value)
  const options = [{ value: '', label: 'Выберите кассира' }, ...choices.items.map((person) => ({ value: person.id, label: person.name }))]
  const hidden = choices.total - choices.items.length
  return <div className="cashier-picker">
    {!locked && <TextField label="Найти кассира по имени" type="search" value={search} onChange={setSearch} />}
    <SelectField label="Кассир" value={value} options={options} disabled={locked} onChange={onChange} />
    {locked && <small role="note">{OWN_ONLY_NOTE}</small>}
    {!locked && hidden > 0 && <small role="note">Показаны первые {CASHIER_PICKER_LIMIT} из {choices.total}: остальных найдите по имени</small>}
    {!locked && search.trim() !== '' && choices.total === 0 && <small role="note">По этому имени кассиров нет</small>}
  </div>
}
